/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable react/prop-types */
import React from 'react';
import { Card, Col, Row, ProgressBar } from 'react-bootstrap';
import { Icon } from '@iconify/react';
import ReactEChartsCore from 'echarts-for-react/lib/core';
import * as echarts from 'echarts/core';
import styled from '@emotion/styled';
import { useAppContext } from 'providers/AppProvider';

const EmployeeLeaveDetailCard = ({ className, data, employeeLeaveData }) => {
  const IconBox = styled('div')`
    margin-right: 6px;
    padding: 7px 0px;
    display: flex;
    font-size: 22px;
    opacity: 0.9;
    display: 'flex';
    align-items: center;
  `;

  // consumed_leave.consumed_leave;
  const totalLeave =
    employeeLeaveData?.consumed_leave?.HD?.quota +
    employeeLeaveData?.consumed_leave?.EL?.quota +
    employeeLeaveData?.consumed_leave?.CL?.quota +
    employeeLeaveData?.consumed_leave?.SL?.quota;

  const takenLeave =
    employeeLeaveData?.consumed_leave?.HD?.taken +
    employeeLeaveData?.consumed_leave?.EL?.taken +
    employeeLeaveData?.consumed_leave?.CL?.taken +
    employeeLeaveData?.consumed_leave?.SL?.taken;
  const leaveData = {
    total: 6,
    hd: employeeLeaveData?.consumed_leave?.HD?.taken,
    el: employeeLeaveData?.consumed_leave?.EL.taken,
    cl: employeeLeaveData?.consumed_leave?.CL.taken,
    sl: employeeLeaveData?.consumed_leave?.SL.taken,
    totalLeave: totalLeave,
    takenLeave: takenLeave,
    remainingLeave: totalLeave - takenLeave
  };

  const calculatePercent = (taken, total) => (taken / total) * 100;

  const leavePercentageData = {
    hdPercent: calculatePercent(leaveData.hd, leaveData.total),
    clPercent: calculatePercent(leaveData.cl, leaveData.total),
    slPercent: calculatePercent(leaveData.sl, leaveData.total),
    elPercent: calculatePercent(leaveData.el, leaveData.total),
    totalPercent: 50, // Example: total percentage consumed
    remainingPercent: 100 - 50 // Remaining percentage
  };

  const { getThemeColor } = useAppContext();

  const getDefaultOptions = (getThemeColor, leaveData) => ({
    color: [getThemeColor('info'), getThemeColor('warning')],
    tooltip: {
      trigger: 'item',
      formatter: params => `<strong>${params.name}:</strong> ${params.value}`
    },
    legend: { show: false },
    series: [
      {
        name: '',
        type: 'pie',
        radius: ['100%', '87%'],
        label: {
          show: true,
          position: 'center',
          formatter: () => `${leaveData.takenLeave}/${leaveData.totalLeave}`, // Show taken/total
          fontSize: 14,
          fontWeight: 'bold',
          color: getThemeColor('dark')
        },
        labelLine: { show: false },
        data: [
          { value: leaveData.takenLeave, name: 'Leaves Taken' }, // Taken leave (7)
          { value: leaveData.remainingLeave, name: 'Remaining Leave' } // Remaining leave (17)
        ]
      }
    ]
  });

  return (
    <Card className="mt-2">
      <Card.Body>
        <div className="p-1">
          <h3>Consumed Leave Type</h3>
          <Row className="align-items-center g-sm-1 mt-0">
            <Col xs={12} md={12} lg={12} xl={8}>
              <Row className="mb-3 mt-2">
                <Col
                  xs={12}
                  lg={12}
                  xl={6}
                  className="d-flex align-items-center mb-2"
                >
                  <h5 className="mb-0 text-success">HD:</h5>
                  <p className="text-800 mb-0 fs-8 ms-2">Half Day</p>
                </Col>
                <Col
                  xs={12}
                  lg={12}
                  xl={6}
                  className="d-flex align-items-center mb-2"
                >
                  <h5 className="mb-0  text-primary">CL:</h5>
                  <p className="text-800 mb-0 fs-8 ms-2">Casual Leave</p>
                </Col>
                <Col
                  xs={12}
                  lg={12}
                  xl={6}
                  className="d-flex align-items-center mb-2"
                >
                  <h5 className="mb-0  text-warning">SL:</h5>
                  <p className="text-800 mb-0 fs-8 ms-2">Sick Leave</p>
                </Col>
                <Col
                  xs={12}
                  lg={12}
                  xl={6}
                  className="d-flex align-items-center"
                >
                  <h5 className="mb-0 text-danger">EL:</h5>
                  <p className="text-800 mb-0 fs-8 ms-2">Emergency Leave</p>
                </Col>
              </Row>
            </Col>

            {/* Pie Chart */}
            <Col
              xs={12}
              md={12}
              lg={12}
              xl={4}
              className="d-flex justify-content-center align-items-center text-center mb-4"
            >
              <IconBox>
                <ReactEChartsCore
                  echarts={echarts}
                  option={getDefaultOptions(getThemeColor, leaveData)}
                  style={{ height: '90px', width: '90px' }}
                />
              </IconBox>
            </Col>
          </Row>
        </div>

        {/* Progress Bars */}
        <div>
          <Row className="align-items-center mb-3">
            <Col xs="auto" className="pe-2">
              <h6 className="mb-0 text-success">HD:</h6>
            </Col>
            <Col>
              <ProgressBar
                variant="success"
                now={leavePercentageData.hdPercent}
                label={leaveData.hd}
                style={{ height: '15px' }}
              />
            </Col>
            <Col xs="auto" className="pe-2">
              <p className="mb-0">
                {leaveData.hd}/{employeeLeaveData?.consumed_leave?.HD?.quota}
              </p>
            </Col>
          </Row>

          <Row className="align-items-center mb-3">
            <Col xs="auto" className="pe-2">
              <h6 className="mb-0 text-primary">CL:</h6>
            </Col>
            <Col>
              <ProgressBar
                variant="info"
                now={leavePercentageData.clPercent}
                label={leaveData.cl}
                style={{ height: '15px' }}
              />
            </Col>
            <Col xs="auto" className="pe-2">
              <p className="mb-0">
                {leaveData.cl}/{employeeLeaveData?.consumed_leave?.CL?.quota}
              </p>
            </Col>
          </Row>

          <Row className="align-items-center mb-3">
            <Col xs="auto" className="pe-2">
              <h6 className="mb-0 text-warning">SL:</h6>
            </Col>
            <Col>
              <ProgressBar
                variant="warning"
                now={leavePercentageData.slPercent}
                label={leaveData.sl}
                style={{ height: '15px' }}
              />
            </Col>
            <Col xs="auto" className="pe-2">
              <p className="mb-0">
                {leaveData.sl}/{employeeLeaveData?.consumed_leave?.SL?.quota}
              </p>
            </Col>
          </Row>

          <Row className="align-items-center">
            <Col xs="auto" className="pe-2">
              <h6 className="mb-0 text-danger">EL:</h6>
            </Col>
            <Col>
              <ProgressBar
                variant="danger"
                now={leavePercentageData.elPercent}
                label={leaveData.el}
                style={{ height: '15px' }}
              />
            </Col>
            <Col xs="auto" className="pe-2">
              <p className="mb-0">
                {leaveData.el}/{employeeLeaveData?.consumed_leave?.EL?.quota}
              </p>
            </Col>
          </Row>
        </div>
      </Card.Body>
    </Card>
  );
};

export default EmployeeLeaveDetailCard;
